import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { Toast } from 'vant';
import './common/stylus/index.styl'
import './common/iconfont/iconfont.css'
import 'mint-ui/lib/style.css'
import cal from './common/lib/utils/calculation'
import "../public/iconfont.css";
Vue.prototype.cal = cal
// import './common/lib/wechat'

// import jquery  from 'jquery';
// global.jquery = global.$ = jquery;

Vue.use(Toast);

Vue.prototype.$http=axios

Vue.config.productionTip = false

Vue.prototype.$http.interceptors.response.use( response => {
  if (response.data.code == 101) {
    store.dispatch('logout')
    router.replace({
      path: '/'
    })
  } else {
    return response
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
